<template>
  <div class="login-module">
    <div class="login-tab" :class="source ? 'login-tabs' : ''">
      <div class="close-btn" @click="close" v-if="source != 1">
        <span
          class="iconfont icon-a-CombinedShape4"
          style="font-size: 12px"
        ></span>
      </div>

      <p class="login-textc">注册</p>
      <p class="login-texte">REGISTER</p>
      <p class="login-textes" v-if="source == 1">
        <el-tooltip placement="bottom-start">
          <div class="tool" slot="content">
            三个课堂平台、集控管理平台注册用户<br />需授权进行使用
            <!-- 三个课堂平台、集控管理平台、远程互<br />动软件客户端注册用户需授权进行使用 -->
          </div>
          <svg
            @click.stop="handleClickOut"
            class="icon icon-a-Oval21"
            aria-hidden="true"
          >
            <use xlink:href="#icon-a-Oval21"></use>
          </svg>
        </el-tooltip>
      </p>
      <!-- <div class="errorhint" v-show="errorhint">{{errorhinttext}}</div> -->
      <el-form
        label-width="80px"
        class="phoneinput"
        :model="editForm"
        label-position="left"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="手机号" prop="userName">
          <el-input
            @input="amendpasswordClick"
            @blur="passverifymold"
            maxlength="11"
            v-model="editForm.userName"
            placeholder="请输入手机号"
          ></el-input>

          <div class="Inconsistent" v-show="moldState">{{ moldTxt }}</div>
        </el-form-item>
        <el-form-item label="验证码" prop="codes">
          <el-input
            maxlength="6"
            class="codenum"
            @input="amendpasswordClick"
            :readonly="readonlyInput"
            @focus="cancelReadOnly()"
            v-model="editForm.codes"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            :class="errorhintmold ? 'nobtn' : 'yesbtn'"
            @click="verification"
            :disabled="errorhintmold"
          >
            {{ btntxt }}
          </el-button>
          <div class="Inconsistent" v-show="captchaState">
            {{ captchaStatetxt }}
          </div>
        </el-form-item>
        <el-form-item label="密码" prop="newPassword">
          <div class="pasdt" v-if="newPasS">
            <p v-if="!pasStrength">
              <span style="color:#f5222d;" v-show="pasStrengthtxt == '太短'"
                >强度：{{ pasStrengthtxt }}</span
              >
              <span style="color:#f5222d;" v-show="pasStrengthtxt !== '太短'">{{
                pasStrengthtxt
              }}</span>
              <el-progress
                :percentage="29"
                :stroke-width="8"
                :text-inside="true"
                :format="format"
                :color="customColor"
              ></el-progress>
            </p>
            <p v-else>
              <span style="color:#52c41a;">强度：安全</span>
              <el-progress
                :percentage="100"
                :stroke-width="8"
                :text-inside="true"
                :format="format"
                :color="customColor"
              ></el-progress>
            </p>

            <br />
            请至少输入 6
            个字符。且包含大写字母，小写字母，数字，下划线至少三种组合
          </div>
          <el-input
            @input="amendpasswordClicknnew"
            @blur="passverifymoldnem"
            maxlength="16"
            :readonly="readonlyInput"
            @focus="cancelReadOnly()"
            v-model="editForm.newPassword"
            :type="newpasswordType"
            placeholder="6 - 16位支持字母、数字、下划线"
          ></el-input>

          <img
            v-show="isShoweyenew == true"
            v-if="newpasswordType != ''"
            class="look"
            src="../../assets/images/guangbi.png"
            alt
            @click="newshowPassword"
          />

          <img
            v-show="isShoweyenew == true"
            v-else
            class="look"
            src="../../assets/images/chakan.png"
            alt
            @click="newshowPassword"
          />
          <div class="Inconsistent" v-show="errorhintpass">
            {{ errorhinttextpass }}
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="againpasswordnumber">
          <el-input
            @input="amendpasswordClickqr"
            maxlength="16"
            v-model="editForm.againpasswordnumber"
            :type="okqrpasswordType"
            placeholder="请再次输入密码"
          ></el-input>
          <img
            v-show="isShoweyeqr == true"
            v-if="okqrpasswordType != ''"
            class="look"
            src="../../assets/images/guangbi.png"
            alt
            @click="okshowPassword"
          />

          <img
            v-show="isShoweyeqr == true"
            v-else
            class="look"
            src="../../assets/images/chakan.png"
            alt
            @click="okshowPassword"
          />
          <div class="Inconsistent" v-show="inconsistent">
            两次密码不一致
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button
          :disabled="amendpassword"
          type="primary"
          @click="changePassword"
          >注册</el-button
        >

        <!-- amendpassword -->
      </div>
      <div class="right-bottom" v-if="source != 1">
        <span @click="handleTab">使用已有账号登录 ></span>
      </div>

      <HintPrompt :markedwords="markedwords" v-show="hintpromptstate" />
    </div>
  </div>
</template>

<script>
import AES from "@/utils/AES";
import HintPrompt from "@/components/wx-hintprompt";
import { login, userById, isUse, ForgetPassCode } from "@/api/login";
import { getUuid, removeToken, removeUuid } from "@/utils/auth";
import { checkPassword, updatePassword } from "@/api/usermenu";
import { registerPhoneNumber, registerCaptcha } from "@/api/register";
import { filterNUmber, allow } from "@/utils/validate";
export default {
  components: { HintPrompt },
  props: {
    activeName: String,
    loginparameters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      newPasS: false,
      customColor: [
        { color: "#f5222d", percentage: 30 },
        { color: "#52C41A", percentage: 100 }
      ],
      pasStrength: false,
      pasStrengthtxt: "太短",
      source: this.$route.query.source,
      platformCode: this.$route.query.platformCode,
      hintpromptstate: false, //提示框状态
      markedwords: "", //提示框文字
      moldTxt: "",
      moldState: false,
      timeout: null,
      timeouta: null,
      time: 0, //验证码时间
      btntxt: "获取验证码",
      captchaState: false,
      captchaStatetxt: "", //验证码错误
      errorhintpass: false, //密码
      errorhinttextpass: "", //密码err文本
      amendpassword: true,
      errorhintmold: true,
      logindata: this.loginparameters,
      inconsistent: false,
      hintpromptstate: false, //提示框状态
      markedwords: "", //提示框文字
      getmessageState: false,
      errorhint: false,
      errorhinttext: "",
      isShoweye: false,
      againisShoweye: false,
      originalpasswordType: "password",
      newpasswordType: "password",
      okqrpasswordType: "password",
      isShoweyeyuan: false,
      isShoweyenew: false,
      isShoweyeqr: false,
      oldpassState: false,
      editForm: {
        userName: "",
        codes: "",
        newPassword: "",
        againpasswordnumber: "",
        uuid: getUuid()
      },
      editFormRules: {
        // newPassword: [
        //     {
        //         required: true,
        //         message: "新密码不能为空",
        //         trigger: "blur",
        //     },
        //     {
        //         required: true,
        //         pattern: "",
        //         message: "密码设置不符合要求",
        //         trigger: "blur",
        //     },
        // ],
        // oldPassword: [
        //     {
        //         required: true,
        //         message: "原密码不能为空",
        //         trigger: "blur",
        //     },
        // ],
        // againpasswordnumber: [
        //     {
        //         required: true,
        //         message: "确认密码不能为空",
        //         trigger: "blur",
        //     },
        // ],
      },
      readonlyInput: true
    };
  },
  watch: {
    "editForm.oldPassword": {
      handler(val, oldval) {
        if (val == "") {
          this.oldpassState = false;
        }
      },
      immediate: true,
      deep: true
    },
    "editForm.userName": {
      handler(val, old) {
        if (val != null || val != "") {
          this.editForm.userName = filterNUmber(val);
        }
      },
      immediate: true
    },
    "editForm.codes": {
      handler(val, old) {
        if (val != null || val != "") {
          this.editForm.codes = filterNUmber(val);
        }
      },
      immediate: true
    },
    "editForm.newPassword": {
      handler(val, old) {
        if (val != null || val != "") {
          this.editForm.newPassword = allow(val);
        }
      },
      immediate: true
    },
    "editForm.againpasswordnumber": {
      handler(val, old) {
        if (val != null || val != "") {
          this.editForm.againpasswordnumber = allow(val);
        }
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
    cancelReadOnly() {
      this.readonlyInput = false;
    },
    format(percentage) {
      // return percentage === 100 ? '满' : `${percentage}%`;
      return "";
    },
    handleClickOut(statcode) {
      this.logindata.forgetdata = true;
    },
    //获取验证码
    verification() {
      if (this.time !== 0) {
        return;
      }
      this.getmessageState = true;
      // isUse(this.editForm.userName).then(res => {
      //   if (res.data == 0) {

      //   } else if (res.data == 1) {
      //     this.moldState = true;
      //     this.moldTxt = "账号已注册";
      //   }
      // });
      registerCaptcha({
        platformId: this.platformCode
          ? this.platformCode
          : window.g.platformCode,
        phoneNumber: this.editForm.userName
      }).then(res => {
        if (res.code === 200) {
          this.time = 60;
          this.errorhintmold = true;
          this.hintpromptstate = true;
          this.markedwords = "验证码发送成功";
          this.timeout = setTimeout(() => {
            this.hintpromptstate = false;
          }, 1000);
          this.timer();
        }
      });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s";
        this.timeouta = setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.getmessageState = false;
        this.passverifymold();
      }
    },
    handleTab() {
      if (this.source == 1) {
        // alert("1");
        return;
      }
      this.logindata.logindata = true;
      this.logindata.registration = false;
    },
    close() {
      this.logindata.logindata = true;
      this.logindata.registration = false;
      this.$store.commit("loginState", false);
    },
    // 注册
    changePassword() {
      this.$refs.editForm.validate((valid, value) => {
        if (valid) {
          this.$refs.editForm.validateField("againpasswordnumber", () => {
            const intnumber = new RegExp(
              /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{6,16}$/
            );
            let captcha = /^\d{6}$/;
            if (captcha.test(this.editForm.codes) == false) {
              this.captchaState = true;
              this.captchaStatetxt = "验证码错误";
            } else if (intnumber.test(this.editForm.newPassword) == false) {
              this.errorhintpass = true;
              this.errorhinttextpass = "密码设置不符合要求";
            } else if (
              this.editForm.againpasswordnumber !== this.editForm.newPassword
            ) {
              this.inconsistent = true;
            } else {
              this.inconsistent = false;
              this.captchaState = false;
              this.errorhintpass = false;
              var captchas = AES.encrypt(this.editForm.codes);
              var phoneNumber = AES.encrypt(this.editForm.userName);
              var password = AES.encrypt(this.editForm.newPassword);

              registerPhoneNumber({
                captcha: captchas,
                password: password,
                phoneNumber: phoneNumber,
                platformId: this.platformCode
                  ? this.platformCode
                  : window.g.platformCode
              }).then(res => {
                if (res.code === 200) {
                  this.editForm = {
                    userName: "",
                    codes: "",
                    newPassword: "",
                    againpasswordnumber: "",
                    uuid: getUuid()
                  };

                  if (this.source == 1) {
                    this.btntxt = "获取验证码";
                    this.time = 0;
                    this.$alert("注册成功，请客户端登录", "", {
                      confirmButtonText: "我知道了",
                      center: true,
                      showClose: false,
                      callback: action => {}
                    });
                    return;
                  }
                  this.$message({
                    message: "注册成功",
                    type: "success",
                    center: true
                  });

                  this.logindata.logindata = true;
                  this.logindata.forgetdata = false;
                  this.logindata.settingdata = false;
                  this.logindata.defaultdata = false;
                  this.logindata.registration = false;
                  this.$store.commit("loginState", true);
                  removeToken();
                  removeUuid();
                  localStorage.removeItem("defaultdata");
                  // localStorage.clear();
                  // window.location.reload();
                } else if (res.code == 3000) {
                  this.captchaState = true;
                  this.captchaStatetxt = "验证码错误";
                } else if (res.code == 3001) {
                  this.captchaState = true;
                  this.captchaStatetxt = "验证码错误";
                } else if (res.code == 2004) {
                  this.$message({
                    message: "账号已注册",
                    type: "warning",
                    center: true
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "warning",
                    center: true
                  });
                }
              });
            }
          });
        }
      });
    },
    //手机号验证
    passverifymold() {
      // moldTxt:'',
      // moldState:false,
      if (this.getmessageState) return;
      let phoneInt = /^1[3456789]\d{9}$/;
      if (this.editForm.userName == "") {
        this.errorhintmold = true;
        this.moldTxt = "请输入手机号";
        this.moldState = true;
        this.amendpassword = true;
      } else if (phoneInt.test(this.editForm.userName) == false) {
        this.errorhintmold = true;
        this.moldTxt = "请输入正确的手机号";
        this.moldState = true;
        this.amendpassword = true;
      } else {
        this.moldTxt = "";
        this.moldState = false;
        this.errorhintmold = false;
      }
    },
    // 验证密码
    passverifymoldnem() {
      this.newPasS = false;
      const intnumber = new RegExp(
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{6,16}$/
      );
      if (intnumber.test(this.editForm.newPassword) == false) {
        this.errorhintpass = true;
        this.errorhinttextpass = "密码设置不符合要求";
      } else {
        this.errorhintpass = false;
        this.errorhinttextpass = "密码设置不符合要求";
      }
    },
    newshowPassword() {
      this.newpasswordType === ""
        ? (this.newpasswordType = "password")
        : (this.newpasswordType = "");
    },

    okshowPassword() {
      this.okqrpasswordType === ""
        ? (this.okqrpasswordType = "password")
        : (this.okqrpasswordType = "");
    },
    //修改登录密码
    amendpasswordClick() {
      // console.log(this.editForm.newPassword);
      // console.log(this.editForm.againpasswordnumber);
      // console.log(this.editForm.oldPassword);
      if (this.getmessageState) return;
      let phoneInt = /^1[3456789]\d{9}$/;
      if (
        this.editForm.userName.length == 11 &&
        phoneInt.test(this.editForm.userName)
      ) {
        this.errorhintmold = false;
      } else {
        this.errorhintmold = true;
      }
      let captcha = /^\d{6}$/;
      if (captcha.test(this.editForm.codes)) {
        this.captchaState = false;
        this.captchaStatetxt = "";
      }

      if (
        this.editForm.userName != "" &&
        this.editForm.codes != "" &&
        this.editForm.newPassword != "" &&
        this.editForm.againpasswordnumber != ""
      ) {
        this.amendpassword = false;
      } else {
        this.amendpassword = true;
      }

      this.isShoweyeyuan = false;
      this.inconsistent = false;
      if (this.editForm.oldPassword == "") {
        this.isShoweyeyuan = false;
        this.passwordType = "password";
      } else {
        this.isShoweyeyuan = true;
      }
    },

    amendpasswordClicknnew() {
      if (
        this.editForm.userName != "" &&
        this.editForm.codes != "" &&
        this.editForm.newPassword != "" &&
        this.editForm.againpasswordnumber != ""
      ) {
        this.amendpassword = false;
      } else {
        this.amendpassword = true;
      }

      this.isShoweyenew = false;
      this.inconsistent = false;
      if (this.editForm.newPassword == "") {
        this.isShoweyenew = false;
        this.passwordType = "password";
        this.newPasS = false;
      } else {
        this.isShoweyenew = true;
        this.newPasS = true;
        const intnumber = new RegExp(
          /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{6,16}$/
        );
        if (intnumber.test(this.editForm.newPassword)) {
          this.pasStrength = true;
        } else {
          this.pasStrength = false;
          if (this.editForm.newPassword.length < 6) {
            this.pasStrengthtxt = "太短";
          } else {
            this.pasStrengthtxt = "密码设置不符合要求";
          }
        }
      }
    },
    amendpasswordClickqr() {
      if (
        this.editForm.userName != "" &&
        this.editForm.codes != "" &&
        this.editForm.newPassword != "" &&
        this.editForm.againpasswordnumber != ""
      ) {
        this.amendpassword = false;
      } else {
        this.amendpassword = true;
      }
      this.isShoweyeqr = false;
      this.inconsistent = false;
      if (this.editForm.againpasswordnumber == "") {
        this.isShoweyeqr = false;
        this.passwordType = "password";
      } else {
        this.isShoweyeqr = true;
      }
    }
  },
  mounted() {},
  destroyed() {},
  created() {},
  updated() {}
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import './index.styl';
/deep/ .tool{
  text-align: left
  position 10px
}
.el-button.is-disabled:hover{
  background-color: #CCC !important
  }
</style>



// WEBPACK FOOTER //
// src/components/setuesName/index.vue